<automatic-debit-breadcrumb [items]="breadcrumbItems"></automatic-debit-breadcrumb>

<div class="container mt-4">
    <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
        <li [ngbNavItem]="pages.generateRem.id">
            <a class="btn btn-outline-primary" ngbNavLink> {{ pages.generateRem.title }} </a>
            <ng-template ngbNavContent>
                <div class="card">
                    <div class="card-header text-center bg-file-header">
                        <h4>
                            Gerar Arquivo de Débito Automático
                            <i *ngIf="loading" class="fa fa-spinner fa-spin fa-2x float-right text-warning"></i>
                            <select
                                *ngIf="contractListFilter.length > 0"
                                class="custom-select mx-5 float-right"
                                style="width: auto"
                                [(ngModel)]="versionFile">
                                <option [ngValue]="4">Versão 4</option>
                                <option [ngValue]="5">Versão 5</option>
                                <option [ngValue]="8">Versão 8</option>
                            </select>
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <label> Selecione o Banco: </label>
                                <select
                                    (change)="emptDataToFilter()"
                                    class="form-control"
                                    [(ngModel)]="companySelected">
                                    <option *ngFor="let company of companyBank" [ngValue]="company">
                                        {{ company.code }} - {{ company.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <label>Data Inicial:</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    [(ngModel)]="dateSelected"
                                    (change)="emptDataToFilter()"
                                    required />
                            </div>
                            <div class="col-md-2">
                                <br />
                                <button (click)="filterDate()" class="btn btn-success">
                                    <span class="fa fa-search"></span>
                                    Buscar
                                </button>
                            </div>
                        </div>

                        <br />

                        <div class="row" *ngIf="datesFind.length > 0">
                            <div class="col-md-4">
                                <label> Vencimentos:</label>

                                <div class="w-100 p-2">
                                    <div *ngFor="let value of datesFind; let i = index">
                                        <input
                                            class="checkbox-size"
                                            [id]="'checkbox-' + i"
                                            type="checkbox"
                                            [checked]="value.selected"
                                            (change)="toggleSelection(value)" />
                                        <label [ngClass]="classSelected(value)" class="pointer" [for]="'checkbox-' + i">
                                            <span class="ml-3 text-14">{{ value.date }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label>Observações:</label>
                                <p class="text-danger">
                                    Serão buscados boletos de alunos com vencimento <br />
                                    a partir da data inicial + 7 dias.
                                </p>
                            </div>
                        </div>

                        <br />

                        <div class="row">
                            <div class="col-md-6">
                                <div *ngIf="fileNameGenerated" class="alert alert-success-2" role="alert">
                                    <h4 class="alert-heading">
                                        <span class="fa fa-check text-success"></span>
                                        Arquivo : {{ fileNameGenerated }}
                                    </h4>
                                </div>
                            </div>
                            <div class="col-md-6 text-right">
                                <br />
                                <button class="btn btn-secondary mr-5" [disabled]="loading" (click)="btnCancel()">
                                    Cancelar
                                </button>

                                <button class="btn btn-success" [disabled]="loading" (click)="generateFile()">
                                    Gerar Arquivo
                                </button>
                            </div>
                        </div>

                        <hr />
                        <br />
                        <br />
                        <div class="panel">
                            <div class="row">
                                <div class="col-sm-12">
                                    <automatic-debit-table
                                        #automaticDebitTableView
                                        [contractListFilter]="contractListFilter"></automatic-debit-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>

        <li [ngbNavItem]="pages.fileRem.id">
            <a class="btn btn-outline-primary" (click)="enterFilePages()" ngbNavLink> {{ pages.fileRem.title }}</a>
            <ng-template ngbNavContent>
                <automatic-debit-files #automaticDebitFilesTableView></automatic-debit-files>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
</div>
